import Breadcrumb from "../components/Breadcrumb";
import UpdateClient from "../components/UpdateClient";

const UpdateClientPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Update Client" />

      <UpdateClient />
    </>
  );
};

export default UpdateClientPage;
